const NotificationsCard = () => {
  return null;
};

export default NotificationsCard;
